import React from 'react';
import '../../../styles/modes/autoMode.css';

/**
 * Solve result display component
 * 
 * @param {Object} props
 * @param {Object} props.solveResult - The result of solving TSP
 * @param {Array} props.locations - Array of location objects
 * @param {Object} props.algorithms - Dictionary of algorithm information
 * @param {boolean} props.showPathDetails - Whether to show path details
 * @param {Function} props.togglePathDetails - Function to toggle path details
 * @returns {JSX.Element}
 */
const SolveResult = ({
  solveResult, 
  locations, 
  algorithms, 
  showPathDetails, 
  togglePathDetails
}) => {
  if (!solveResult) return null;

  return (
    <div className="solve-result">
      <h5>Solving Result</h5>
      <div className="result-details">
        <p><strong>Total Distance:</strong> {solveResult.distance.toFixed(2)} km</p>
        <p><strong>Estimated Time:</strong> {solveResult.time.toFixed(0)} minutes</p>
        <p><strong>Algorithm Used:</strong> {algorithms[solveResult.algorithm]?.name || solveResult.algorithm}</p>
        <p><strong>Path Sequence:</strong></p>
        <div className="path-sequence">
          {solveResult.path.map((id, index) => {
            const loc = locations.find(l => l.id === id);
            return (
              <div key={`${id}-${index}`} className="path-point">
                <span className="path-name">{loc ? loc.name : id}</span>
                {index < solveResult.path.length - 1 && <span className="path-arrow">→</span>}
              </div>
            );
          })}
        </div>
        
        {/* Path details button */}
        <button 
          className="path-details-button"
          onClick={togglePathDetails}
        >
          {showPathDetails ? 'Hide Path Details' : 'Show Path Details'}
        </button>
      </div>
    </div>
  );
};

export default SolveResult; 